/* global axios */

import PortalsAPI from './portals';
import { getArticleSearchURL } from 'dashboard/helper/URLHelper.js';

class ArticlesAPI extends PortalsAPI {
  constructor() {
    super('articles', { accountScoped: true });
  }

  getArticles({
    pageNumber,
    portalSlug,
    locale,
    status,
    authorId,
    categorySlug,
    sort,
  }) {
    const url = getArticleSearchURL({
      pageNumber,
      portalSlug,
      locale,
      status,
      authorId,
      categorySlug,
      sort,
      host: this.url,
    });

    return axios.get(url);
  }

  searchArticles({ portalSlug, query }) {
    const url = getArticleSearchURL({
      portalSlug,
      query,
      host: this.url,
    });
    return axios.get(url);
  }

  getArticle({ id, portalSlug }) {
    return axios.get(`${this.url}/${portalSlug}/articles/${id}`);
  }

  updateArticle({ portalSlug, articleId, articleObj }) {
    return axios.patch(
      `${this.url}/${portalSlug}/articles/${articleId}`,
      articleObj
    );
  }

  promoteDraft({ portalSlug, articleId }) {
    return axios.post(
      `${this.url}/${portalSlug}/articles/${articleId}/promote_draft`
    );
  }

  discardDraft({ portalSlug, articleId }) {
    return axios.delete(
      `${this.url}/${portalSlug}/articles/${articleId}/discard_draft`
    );
  }

  createArticle({ portalSlug, articleObj }) {
    const { content, title, authorId, categoryId, locale } = articleObj;
    return axios.post(`${this.url}/${portalSlug}/articles`, {
      content,
      title,
      author_id: authorId,
      category_id: categoryId,
      locale,
    });
  }

  deleteArticle({ articleId, portalSlug }) {
    return axios.delete(`${this.url}/${portalSlug}/articles/${articleId}`);
  }

  reorderArticles({ portalSlug, reorderedGroup, categorySlug }) {
    return axios.post(`${this.url}/${portalSlug}/articles/reorder`, {
      positions_hash: reorderedGroup,
      category_slug: categorySlug,
    });
  }

  searchMutations({ portalSlug, articleId, query }) {
    return axios.get(
      `${this.url}/${portalSlug}/articles/${articleId}/mutations`,
      { params: { query } }
    );
  }

  addMutations({ portalSlug, articleId, articleIds }) {
    return axios.post(
      `${this.url}/${portalSlug}/articles/${articleId}/mutations`,
      { article_ids: articleIds }
    );
  }

  removeMutation({ portalSlug, articleId, mutationId }) {
    return axios.delete(
      `${this.url}/${portalSlug}/articles/${articleId}/mutations/${mutationId}`
    );
  }

  getVersions({ portalSlug, articleId }) {
    return axios.get(
      `${this.url}/${portalSlug}/articles/${articleId}/versions`
    );
  }

  getVersion({ portalSlug, articleId, versionId }) {
    return axios.get(
      `${this.url}/${portalSlug}/articles/${articleId}/versions/${versionId}`
    );
  }

  restoreVersion({ portalSlug, articleId, versionId }) {
    return axios.post(
      `${this.url}/${portalSlug}/articles/${articleId}/versions/${versionId}/restore`
    );
  }

  translateArticle({ portalSlug, articleId, locales }) {
    return axios.post(
      `${this.url}/${portalSlug}/articles/${articleId}/translations`,
      { locales }
    );
  }
}

export default new ArticlesAPI();
